import { fetchJson } from '../lib/api';
import type { ReviewOffer } from '../lib/offerComparison';
import type { PurchaseChoices } from '../lib/offerSelection';

export type SavedPurchaseSelection = {
  id: string; version: number; name: string; basis: 'last' | 'best'; saved_at: string;
  offers: ReviewOffer[]; choices: PurchaseChoices; sources_current: boolean; can_edit: boolean;
};
export type PurchaseSelectionList = {
  items: Array<{ id: string; version: number; name: string; saved_at: string; offer_count: number; position_count: number }>;
  has_more: boolean; can_edit: boolean;
};
export const fetchPurchaseSelections = (offset = 0, limit = 20) => fetchJson<PurchaseSelectionList>(`/api/purchase-selections?offset=${offset}&limit=${limit}`);
export const fetchPurchaseSelection = (id: string) => fetchJson<SavedPurchaseSelection>(`/api/purchase-selections/${encodeURIComponent(id)}`);
export function savePurchaseSelection(id: string, name: string, expectedVersion: number, offers: ReviewOffer[], choices: PurchaseChoices) {
  return fetchJson<SavedPurchaseSelection>(`/api/purchase-selections/${encodeURIComponent(id)}`, {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: name.trim(), expected_version: expectedVersion, basis: offers[0].preview.reference_basis ?? 'last',
      offers: offers.map(offer => ({ id: offer.docId, token: offer.preview.selection_token })), choices }),
  });
}
export const purchaseSelectionUrl = (id: string) => `/angebote/auswahl/${encodeURIComponent(id)}`;
